@if (logging) {
  <div class="spinner">
    <mat-spinner style="margin: 0 auto" [diameter]="80"></mat-spinner>
  </div>
}
